'use strict';

import uiRouter from '@uirouter/angularjs';

class LoginStateControl {
  /*@ngInject*/
  constructor($location, $state, $rootScope) {
    this.currentHostname = $location.host();
    this.isAdminMode = $location.search().admin_mode;
    this.demandId = $location.search().demand_id;

    this.location = $location;
    this.rootScope = $rootScope;

    this.$state = $state;
  }

  goHome(user) {
    if (this.rootScope.next) {
      this.$state.go(this.rootScope.next.name, this.rootScope.next.params);
      this.rootScope.next = null;
      return;
    }

    if (user.configName === 'oemUser') {
      this.$state.go('oem_main.oem_home');
    } else {
      this.$state.go('main.home');
    }
  }

  goLogin(next) {
    let confirmationToken = this.location.search().confirm_token;
    if (next && next.url !== '/') {
      this.rootScope.next = next;
    }

    if (this.currentHostname.match(/-admin/) || this.isAdminMode) {
      if (confirmationToken) {
        this.$state.go('oem_user_confirm', {token: confirmationToken});
      } else {
        this.$state.go('oem_login');
      }
    } else {
      if (confirmationToken) {
        this.$state.go('end_user_confirm', {token: confirmationToken});
      } else {
        this.$state.go('login');
      }
    }
  }

  rootToHome(user) {
    if (this.location.path() === '/') {
      this.goHome(user);
    }
  }
}

export default angular.module('leptonApp.LoginStateControl', [uiRouter])
  .service('LoginStateControl', ['$location', '$state', '$rootScope', LoginStateControl])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/logic/login_state_control/login_state_control.js